import styled from 'styled-components'

import { ColumnItem, AlignCenterItem } from '../../../components/common'

import { Color } from '../../../theme/color'

export const FooterContainer = styled.div`
  padding: 24px 24px 54px;
  background-color: ${Color.gray_2};
`

export const FooterDropdown = styled(ColumnItem)<{ isDropdownOpen: boolean }>`
  overflow: hidden;
  ${({ isDropdownOpen }) => (isDropdownOpen ? '' : 'height: 26px;')}
  margin-top: 16px;
  > ${AlignCenterItem} {
    margin-bottom: 8px;
    cursor: pointer;
    > svg {
      ${({ isDropdownOpen }) => (isDropdownOpen ? 'transform: rotateZ(180deg);' : '')}
    }
  }
`
